import { useSelector } from 'react-redux';
import { InputField } from '../../../../components/FormComponents';
import { Text } from '../../../../ui-component';

import type { RootState } from '../../../../store';
import { useGetSiteConstantValue } from '../../../../utils/hooks/useGetSiteConstantValue';

type StepTwoProps = {
  handleChange: (value: any, key: string) => void;
};

const StepTwo = (props: StepTwoProps) => {
  const { handleChange } = props;

  const { getSiteConstantValue } = useGetSiteConstantValue();

  const { onboardingReducer } = useSelector((state: RootState) => state);
  const { profileData } = onboardingReducer;

  return (
    <>
      <Text size="xxxl" color="black" fontWeight={800}>
        {getSiteConstantValue('profile', 'howManyPeopleWorkInBoutique')}
      </Text>

      <InputField
        label={getSiteConstantValue('profile', 'betterCustomizedExperienceText')}
        placeholder={getSiteConstantValue('profile', 'betterCustomizedExperienceText')}
        type="text"
        required={true}
        value={profileData?.tailor_count ?? ''}
        onChange={(value) => handleChange(value, 'tailor_count')}
      />
    </>
  );
};

export default StepTwo;
